import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSEmail: { input: any; output: any; }
};

export type AddDestinationInput = {
  documentType: Scalars['String']['input'];
  fromOrganizationCode: Scalars['String']['input'];
  fromOrganizationType: Scalars['String']['input'];
  toOrganizationCode: Scalars['String']['input'];
  toOrganizationType: Scalars['String']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Status;
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  id: Scalars['ID']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: Status;
  url: Scalars['String']['input'];
};

export type Attachments = {
  __typename?: 'Attachments';
  application: Scalars['String']['output'];
  attachments: Array<Attachment>;
  owner: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parentType: Scalars['String']['output'];
};

export type AttachmentsInput = {
  application: Scalars['String']['input'];
  attachments: Array<AttachmentInput>;
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export type Configuration = {
  __typename?: 'Configuration';
  community: Scalars['ID']['output'];
  enums: Array<Enumeration>;
};

export type DeleteEnumerationValueInput = {
  code: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type Destination = {
  __typename?: 'Destination';
  organizationCode: Scalars['String']['output'];
  organizationType: Scalars['String']['output'];
};

export type Document = {
  __typename?: 'Document';
  attachments: Array<Attachment>;
  crn: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rejectionMessages?: Maybe<Array<Scalars['String']['output']>>;
  scope: Scope;
  status: Scalars['String']['output'];
};

export enum DocumentStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Draft = 'DRAFT',
  None = 'NONE',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type DocumentUpdate = {
  __typename?: 'DocumentUpdate';
  crn: Scalars['String']['output'];
  document: Document;
  organization: Scalars['String']['output'];
};

export type Documents = {
  __typename?: 'Documents';
  documents: Array<Document>;
  organization: Scalars['String']['output'];
};

export type EnumValue = {
  __typename?: 'EnumValue';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentValue?: Maybe<Scalars['String']['output']>;
};

export type EnumValueInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentValue?: InputMaybe<Scalars['String']['input']>;
};

export type Enumeration = {
  __typename?: 'Enumeration';
  parentType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  values: Array<Maybe<EnumValue>>;
};

export type EnumerationInput = {
  type: Scalars['String']['input'];
  values: Array<EnumValueInput>;
};

export type EnumerationValueInput = {
  parentType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value: EnumValueInput;
};

export type GetAttachmentsInput = {
  application: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export type GetDocumentsInput = {
  crn: Scalars['String']['input'];
};

export type IdFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelOrganizationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationFilterInput>>>;
  code?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ModelOrganizationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationFilterInput>>>;
};

export type ModelUserFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserFilterInput>>>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ModelUserFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserFilterInput>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDestination?: Maybe<Routing>;
  createAdmin?: Maybe<User>;
  createOrganization?: Maybe<Organization>;
  createUser?: Maybe<User>;
  deleteEnumValue?: Maybe<Configuration>;
  deleteUser: User;
  notifyCommunityAttachmentsUpdate?: Maybe<Attachments>;
  notifyDocumentUpdate?: Maybe<DocumentUpdate>;
  notifyOrganizationAttachmentsUpdate?: Maybe<Attachments>;
  publish?: Maybe<DocumentUpdate>;
  putEnum?: Maybe<Configuration>;
  putEnumValue?: Maybe<Configuration>;
  refreshClientSecret: RefreshClientSecretResult;
  setAssignableRoles?: Maybe<Organization>;
  setRoles: User;
};


export type MutationAddDestinationArgs = {
  input: AddDestinationInput;
};


export type MutationCreateAdminArgs = {
  email: Scalars['AWSEmail']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationCode: Scalars['String']['input'];
  organizationType: Scalars['String']['input'];
};


export type MutationCreateOrganizationArgs = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['AWSEmail']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteEnumValueArgs = {
  input: DeleteEnumerationValueInput;
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationNotifyCommunityAttachmentsUpdateArgs = {
  input: GetAttachmentsInput;
  organization: Scalars['String']['input'];
};


export type MutationNotifyDocumentUpdateArgs = {
  organization: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};


export type MutationNotifyOrganizationAttachmentsUpdateArgs = {
  input: GetAttachmentsInput;
  organization: Scalars['String']['input'];
};


export type MutationPublishArgs = {
  input: PublishInput;
};


export type MutationPutEnumArgs = {
  input: EnumerationInput;
};


export type MutationPutEnumValueArgs = {
  input: EnumerationValueInput;
};


export type MutationSetAssignableRolesArgs = {
  assignableRoles: Array<Scalars['String']['input']>;
  organizationCode: Scalars['String']['input'];
  organizationType: Scalars['String']['input'];
};


export type MutationSetRolesArgs = {
  roles: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  assignableRoles: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  communityCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OwnOrganization = {
  __typename?: 'OwnOrganization';
  assignableRoles: Array<Scalars['String']['output']>;
  communityName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PublishInput = {
  crn: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  getAttachments?: Maybe<Attachments>;
  getCommunityAttachments?: Maybe<Attachments>;
  getCommunityCode: Scalars['String']['output'];
  getConfiguration?: Maybe<Configuration>;
  getDocuments?: Maybe<Documents>;
  getOrganization?: Maybe<OwnOrganization>;
  getOrganizationAttachments?: Maybe<Attachments>;
  getOwner: Scalars['String']['output'];
  listCommunityRoles?: Maybe<Array<Scalars['String']['output']>>;
  listMyRoles: Array<Scalars['String']['output']>;
  listOrganizationTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOrganizations?: Maybe<Array<Maybe<Organization>>>;
  listPorts?: Maybe<Array<Maybe<Organization>>>;
  listRoles: Array<Scalars['String']['output']>;
  listUsers?: Maybe<Array<Maybe<User>>>;
};


export type QueryGetAttachmentsArgs = {
  input: GetAttachmentsInput;
};


export type QueryGetCommunityAttachmentsArgs = {
  input: GetAttachmentsInput;
};


export type QueryGetDocumentsArgs = {
  input: GetDocumentsInput;
};


export type QueryGetOrganizationAttachmentsArgs = {
  input: GetAttachmentsInput;
};


export type QueryListOrganizationsArgs = {
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUsersArgs = {
  filter?: InputMaybe<ModelUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type RefreshClientSecretResult = {
  __typename?: 'RefreshClientSecretResult';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type Routing = {
  __typename?: 'Routing';
  classification: Scalars['String']['output'];
  community: Scalars['ID']['output'];
  destinations?: Maybe<Array<Destination>>;
};

export type Scope = {
  __typename?: 'Scope';
  application: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parentType: Scalars['String']['output'];
};

export type ScopeInput = {
  application: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};

export enum Status {
  Clean = 'CLEAN',
  Deleted = 'DELETED',
  Infected = 'INFECTED',
  PendingVirusCheck = 'PENDING_VIRUS_CHECK'
}

export type StringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  attachmentsUpdatedSubscription?: Maybe<Attachments>;
  communityAttachmentsUpdatedSubscription?: Maybe<Attachments>;
  createOrganizationSubscription?: Maybe<Organization>;
  createUserSubscription?: Maybe<User>;
  deleteUserSubscription?: Maybe<User>;
  documentUpdatedSubscription?: Maybe<DocumentUpdate>;
  organizationAttachmentsUpdatedSubscription?: Maybe<Attachments>;
  userUpdatedSubscription?: Maybe<User>;
};


export type SubscriptionAttachmentsUpdatedSubscriptionArgs = {
  application: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


export type SubscriptionCommunityAttachmentsUpdatedSubscriptionArgs = {
  application: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


export type SubscriptionCreateOrganizationSubscriptionArgs = {
  communityCode: Scalars['String']['input'];
};


export type SubscriptionCreateUserSubscriptionArgs = {
  owner: Scalars['String']['input'];
};


export type SubscriptionDeleteUserSubscriptionArgs = {
  owner: Scalars['String']['input'];
};


export type SubscriptionDocumentUpdatedSubscriptionArgs = {
  crn: Scalars['String']['input'];
  organization: Scalars['String']['input'];
};


export type SubscriptionOrganizationAttachmentsUpdatedSubscriptionArgs = {
  application: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


export type SubscriptionUserUpdatedSubscriptionArgs = {
  owner: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CommunityAttachmentsUpdatedSubscriptionSubscriptionVariables = Exact<{
  owner: Scalars['String']['input'];
  application: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
}>;


export type CommunityAttachmentsUpdatedSubscriptionSubscription = { __typename?: 'Subscription', communityAttachmentsUpdatedSubscription?: { __typename?: 'Attachments', owner: string, application: string, parentType: string, parentId: string, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status }> } | null };

export type AttachmentFragment = { __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status };

export type AttachmentsFragment = { __typename?: 'Attachments', owner: string, application: string, parentType: string, parentId: string, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status }> };

export type GetCommunityAttachmentsQueryVariables = Exact<{
  input: GetAttachmentsInput;
}>;


export type GetCommunityAttachmentsQuery = { __typename?: 'Query', getCommunityAttachments?: { __typename?: 'Attachments', owner: string, application: string, parentType: string, parentId: string, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, mimeType: string, url: string, status: Status }> } | null };

export type GetCommunityCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityCodeQuery = { __typename?: 'Query', getCommunityCode: string };

export type GetOwnerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnerQuery = { __typename?: 'Query', getOwner: string };

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolesQuery = { __typename?: 'Query', listRoles: Array<string> };

export const AttachmentFragmentDoc = gql`
    fragment Attachment on Attachment {
  id
  name
  mimeType
  url
  status
}
    `;
export const AttachmentsFragmentDoc = gql`
    fragment Attachments on Attachments {
  owner
  application
  parentType
  parentId
  attachments {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;
export const CommunityAttachmentsUpdatedSubscriptionDocument = gql`
    subscription communityAttachmentsUpdatedSubscription($owner: String!, $application: String!, $parentType: String!, $parentId: String!) {
  communityAttachmentsUpdatedSubscription(
    owner: $owner
    application: $application
    parentType: $parentType
    parentId: $parentId
  ) {
    ...Attachments
  }
}
    ${AttachmentsFragmentDoc}`;

/**
 * __useCommunityAttachmentsUpdatedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useCommunityAttachmentsUpdatedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunityAttachmentsUpdatedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityAttachmentsUpdatedSubscriptionSubscription({
 *   variables: {
 *      owner: // value for 'owner'
 *      application: // value for 'application'
 *      parentType: // value for 'parentType'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCommunityAttachmentsUpdatedSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<CommunityAttachmentsUpdatedSubscriptionSubscription, CommunityAttachmentsUpdatedSubscriptionSubscriptionVariables> & ({ variables: CommunityAttachmentsUpdatedSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommunityAttachmentsUpdatedSubscriptionSubscription, CommunityAttachmentsUpdatedSubscriptionSubscriptionVariables>(CommunityAttachmentsUpdatedSubscriptionDocument, options);
      }
export type CommunityAttachmentsUpdatedSubscriptionSubscriptionHookResult = ReturnType<typeof useCommunityAttachmentsUpdatedSubscriptionSubscription>;
export type CommunityAttachmentsUpdatedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<CommunityAttachmentsUpdatedSubscriptionSubscription>;
export const GetCommunityAttachmentsDocument = gql`
    query getCommunityAttachments($input: GetAttachmentsInput!) {
  getCommunityAttachments(input: $input) {
    ...Attachments
  }
}
    ${AttachmentsFragmentDoc}`;

/**
 * __useGetCommunityAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetCommunityAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityAttachmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommunityAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables> & ({ variables: GetCommunityAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>(GetCommunityAttachmentsDocument, options);
      }
export function useGetCommunityAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>(GetCommunityAttachmentsDocument, options);
        }
// @ts-ignore
export function useGetCommunityAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>;
export function useGetCommunityAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityAttachmentsQuery | undefined, GetCommunityAttachmentsQueryVariables>;
export function useGetCommunityAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>(GetCommunityAttachmentsDocument, options);
        }
export type GetCommunityAttachmentsQueryHookResult = ReturnType<typeof useGetCommunityAttachmentsQuery>;
export type GetCommunityAttachmentsLazyQueryHookResult = ReturnType<typeof useGetCommunityAttachmentsLazyQuery>;
export type GetCommunityAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetCommunityAttachmentsSuspenseQuery>;
export type GetCommunityAttachmentsQueryResult = Apollo.QueryResult<GetCommunityAttachmentsQuery, GetCommunityAttachmentsQueryVariables>;
export const GetCommunityCodeDocument = gql`
    query getCommunityCode {
  getCommunityCode
}
    `;

/**
 * __useGetCommunityCodeQuery__
 *
 * To run a query within a React component, call `useGetCommunityCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>(GetCommunityCodeDocument, options);
      }
export function useGetCommunityCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>(GetCommunityCodeDocument, options);
        }
// @ts-ignore
export function useGetCommunityCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>;
export function useGetCommunityCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityCodeQuery | undefined, GetCommunityCodeQueryVariables>;
export function useGetCommunityCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>(GetCommunityCodeDocument, options);
        }
export type GetCommunityCodeQueryHookResult = ReturnType<typeof useGetCommunityCodeQuery>;
export type GetCommunityCodeLazyQueryHookResult = ReturnType<typeof useGetCommunityCodeLazyQuery>;
export type GetCommunityCodeSuspenseQueryHookResult = ReturnType<typeof useGetCommunityCodeSuspenseQuery>;
export type GetCommunityCodeQueryResult = Apollo.QueryResult<GetCommunityCodeQuery, GetCommunityCodeQueryVariables>;
export const GetOwnerDocument = gql`
    query getOwner {
  getOwner
}
    `;

/**
 * __useGetOwnerQuery__
 *
 * To run a query within a React component, call `useGetOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnerQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
      }
export function useGetOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
        }
// @ts-ignore
export function useGetOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetOwnerQuery, GetOwnerQueryVariables>;
export function useGetOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetOwnerQuery | undefined, GetOwnerQueryVariables>;
export function useGetOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
        }
export type GetOwnerQueryHookResult = ReturnType<typeof useGetOwnerQuery>;
export type GetOwnerLazyQueryHookResult = ReturnType<typeof useGetOwnerLazyQuery>;
export type GetOwnerSuspenseQueryHookResult = ReturnType<typeof useGetOwnerSuspenseQuery>;
export type GetOwnerQueryResult = Apollo.QueryResult<GetOwnerQuery, GetOwnerQueryVariables>;
export const GetUserRolesDocument = gql`
    query getUserRoles {
  listRoles
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
      }
export function useGetUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
// @ts-ignore
export function useGetUserRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRolesQuery, GetUserRolesQueryVariables>;
export function useGetUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRolesQuery | undefined, GetUserRolesQueryVariables>;
export function useGetUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserRolesSuspenseQuery>;
export type GetUserRolesQueryResult = Apollo.QueryResult<GetUserRolesQuery, GetUserRolesQueryVariables>;